import { ClickMenuItem } from './ClickMenu';
import { Icon, IconName } from './Icon';

interface MessageActionMenuItemProps {
  text: string;
  title: string;
  icon: IconName;
  onClick?: () => void;
}

export function MessageActionMenuItem({ icon, title, text, onClick }: MessageActionMenuItemProps) {
  return (
    <ClickMenuItem className="!h-auto py-3 group hover:!bg-palette-600" hideOnClick onClick={onClick}>
      <Icon className="text-palette-600 mr-4 !h-6 !w-6 group-hover:text-palette-800" icon={icon} />
      <div>
        <p className="text-lg font-medium leading-[22px] text-white group-hover:text-palette-1100">{title}</p>
        <p className="text-xs text-gray-light/70 group-hover:text-palette-1100">{text}</p>
      </div>
    </ClickMenuItem>
  );
}
